// Mock data for FnctionOS video editor

export const mockProjects = [
  {
    id: 1,
    name: "Summer Vacation Highlights",
    duration: "1:45",
    status: "completed",
    thumbnail: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgdmlld0JveD0iMCAwIDMyMCAxODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIiBmaWxsPSIjRkY2B0I5Ii8+CjxjaXJjbGUgY3g9IjE2MCIgY3k9IjkwIiByPSIzMCIgZmlsbD0id2hpdGUiLz4KICA8cG9seWdvbiBwb2ludHM9IjE1MCw3NSAxNzUsMTAxIDUsMTAxIiBmaWxsPSIjRkY2QzZEIi8+Cjwvc3ZnPgo=",
    createdAt: "2024-06-15"
  },
  {
    id: 2,
    name: "Product Demo Reel",
    duration: "0:58",
    status: "processing",
    thumbnail: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjE4MCIgdmlld0JveD0iMCAwIDMyMCAxODAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMjAiIGhlaWdodD0iMTgwIiBmaWxsPSIjNkM2M0ZGIi8+CjxjaXJjbGUgY3g9IjE2MCIgY3k9IjkwIiByPSIzMCIgZmlsbD0id2hpdGUiLz4KICA8cG9seWdvbiBwb2ludHM9IjE1MCw3NSAxNzUsMTAxIDUsMTAxIiBmaWxsPSIjNkM2M0ZGIi8+Cjwvc3ZnPgo=",
    createdAt: "2024-06-14"
  }
];

export const mockChatMessages = [
  {
    id: 1,
    type: "user",
    content: "Add captions in white with shadow",
    timestamp: "10:30 AM"
  },
  {
    id: 2,
    type: "ai",
    content: "✨ Added white captions with drop shadow effect! The text is now clearly visible and follows your video's natural speech patterns.",
    timestamp: "10:30 AM"
  },
  {
    id: 3,
    type: "user",
    content: "Cut out all silence",
    timestamp: "10:32 AM"
  },
  {
    id: 4,
    type: "ai",
    content: "🎬 Removed 12 seconds of silence! Your video is now much more engaging and flows smoothly from scene to scene.",
    timestamp: "10:32 AM"
  },
  {
    id: 5,
    type: "user",
    content: "Make it vertical for Instagram",
    timestamp: "10:35 AM"
  },
  {
    id: 6,
    type: "ai",
    content: "📱 Converted to 9:16 vertical format! Perfect for Instagram Reels and TikTok. The composition has been automatically adjusted for mobile viewing.",
    timestamp: "10:35 AM"
  }
];

export const mockTimelineData = {
  duration: 105, // seconds
  clips: [
    { id: 1, start: 0, end: 15, type: "video", name: "Intro Scene" },
    { id: 2, start: 15, end: 45, type: "video", name: "Main Content" },
    { id: 3, start: 45, end: 75, type: "video", name: "Highlight Reel" },
    { id: 4, start: 75, end: 105, type: "video", name: "Outro" }
  ],
  captions: [
    { id: 1, start: 5, end: 12, text: "Welcome to our amazing journey!" },
    { id: 2, start: 20, end: 35, text: "Here's what we discovered along the way..." },
    { id: 3, start: 50, end: 68, text: "The most incredible moments captured!" }
  ]
};

export const mockTranscription = {
  segments: [
    {
      start: 0.5,
      end: 4.2,
      text: "Welcome to our amazing journey!"
    },
    {
      start: 5.1,
      end: 12.8,
      text: "Today we're going to show you some incredible highlights from our recent adventure."
    },
    {
      start: 15.3,
      end: 28.9,
      text: "Here's what we discovered along the way, and trust me, you won't believe what happened next."
    },
    {
      start: 30.2,
      end: 45.7,
      text: "The scenery was absolutely breathtaking, and the experience was unforgettable."
    }
  ]
};

export const mockAiSuggestions = [
  "Add energetic transitions",
  "Remove background noise", 
  "Create 30-second hook",
  "Add trending music",
  "Boost audio levels",
  "Add zoom effects",
  "Create thumbnail",
  "Export for TikTok"
];